<template>
  <div ref="topContainer">
    <MobileHeader v-if="currentStep !== surgApproveStep" />
    <DesktopHeader v-if="currentStep !== surgApproveStep" />

    <!-- Step 2 -->
    <PatientDetails v-if="currentStep === 2" />

    <!-- Step 3 -->
    <SurgeryDetails v-if="currentStep === 3" ref="surgeryDetails" />

    <!-- Step 4 -->
    <AnalysisTools v-if="currentStep === 4" />

    <!-- Step 5 (conditional): Implants suppliers - only when showImplantsSection -->
    <ImplantsSuppliers v-if="currentStep === 5 && showImplantsSection" />

    <!-- Step 5 or 6: Documents -->
    <Documents v-if="currentStep === documentsStep" />

    <!-- Step 6 or 7: Patient requests -->
    <PatientRequests v-if="currentStep === patientRequestsStep" />

    <!-- Step 7 or 8: SurgApprove -->
    <SurgApprove
      v-if="currentStep === surgApproveStep"
      :surgery="surgeryForApproval"
      :files="surgery.files"
      :patientRequests="surgery.patient_requests"
      :sentRequestTypes="surgery.sent_patient_request_types"
      :isAfterEdit="isEditMode"
      @approveGoBack="SET_CURRENT_STEP(patientRequestsStep)"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import SurgApprove from "./SurgerySummary/SurgApprove.vue";
import MobileHeader from "@/components/Dashboard/Surgery/AddSurgery/Layout/MobileHeader.vue";
import DesktopHeader from "@/components/Dashboard/Surgery/AddSurgery/Layout/DesktopHeader.vue";
import PatientDetails from "./AddSurgery/Steps/PatientDetails.vue";
import AnalysisTools from "./AddSurgery/Steps/AnalysisTools.vue";
import ImplantsSuppliers from "./AddSurgery/Steps/ImplantsSuppliers.vue";
import Documents from "./AddSurgery/Steps/Documents.vue";
import PatientRequests from "./AddSurgery/Steps/PatientRequests.vue";
import SurgeryDetails from "./AddSurgery/Steps/SurgeryDetails/index.vue";

var indicator = document.createElement("div");
indicator.className = "state-indicator";
document.body.appendChild(indicator);

export default {
  name: "SurgAdd",
  mounted() {
    this.SET_CURRENT_STEP(2);
  },
  watch: {
    // Every step must open at the top of the page, no matter how we got there
    // (next, back arrow in the headers, or returning from the approval screen).
    currentStep() {
      this.scrollPageToTop();
    }
  },
  beforeDestroy() {
    this.SET_IS_EDIT_MODE(false);
    this.RESET_STATE();
  },
  computed: {
    ...mapState("Surgery", ["currentStep", "surgery", "isEditMode"]),
    ...mapGetters("Surgery", ["surgeryForApproval", "showImplantsSection"]),
    documentsStep() {
      return this.showImplantsSection ? 6 : 5;
    },
    patientRequestsStep() {
      return this.showImplantsSection ? 7 : 6;
    },
    surgApproveStep() {
      return this.showImplantsSection ? 8 : 7;
    }
  },
  methods: {
    ...mapMutations("Surgery", [
      "SET_CURRENT_STEP",
      "SET_IS_EDIT_MODE",
      "RESET_STATE"
    ]),

    /**
     * Scrolls the page back to the top when the step changes.
     * On mobile the step used to open scrolled down (the previous step's
     * position was kept), so the scroll is repeated after the new step is in
     * the DOM and after the first paint.
     */
    scrollPageToTop() {
      // With the mobile keyboard open the browser scrolls the focused field
      // back into view right after we scroll up, so drop the focus first.
      const focused = document.activeElement;
      if (focused && typeof focused.blur === "function") focused.blur();

      const toTop = () => {
        // Positional args scroll instantly and cancel any smooth scroll still
        // running from a scroll-to-error on the step we are leaving.
        window.scrollTo(0, 0);
        // iOS Safari does not always follow window.scrollTo on its own.
        document.documentElement.scrollTop = 0;
        if (document.body) document.body.scrollTop = 0;
      };

      toTop();
      this.$nextTick(() => {
        toTop();
        requestAnimationFrame(toTop);
      });
    }
  },
  components: {
    SurgApprove,
    MobileHeader,
    DesktopHeader,
    PatientDetails,
    AnalysisTools,
    ImplantsSuppliers,
    Documents,
    PatientRequests,
    SurgeryDetails
  }
};
</script>

<style>
.autosuggest__results-container ul,
.autosuggest__results-container li {
  padding: 0;
  display: block;
}

.vs__actions {
  display: none !important;
}

.add_task_width {
  width: 130px;
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

.section-disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

.required-txt {
  padding: 0 12px 12px;
  color: #b00020;
}

.center {
  text-align: center;
}

.surg-clear-btn {
  padding: 5px;
  font-size: 0.85rem;
  position: absolute;
  top: 22px;
  left: 20px;
  z-index: 1;
  cursor: pointer;
  background-color: rgb(240 240 240);
}

.btn-mobile {
  background-color: white;
  top: 14px;
  left: 0px;
}

.surg-side-note {
  display: block;
}

@media only screen and (max-width: 800px) {
  .surg-side-note {
    width: 336px;
  }
}
@media only screen and (min-width: 1200px) {
  .file_row {
    width: 100% !important;
    margin-top: 23px;
  }
  .file_row .add_new_row_col2 {
    width: calc((100% / 3) - 20px);
  }
}
</style>
